module.exports = __webpack_public_path__ + "static/media/jonathanabiharb.93155c36.jpg";